import UploadComponent from '@components/UploadComponent';
import { TypesValidation } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import { Checkbox, DatePicker, Input, InputNumber, Radio, Tree } from 'antd';
import React from 'react';

const { TextArea } = Input;

interface IFieldsValidationPropsType {
  validation?: boolean | boolean[]
  handleOnChange: any;
  messageValidation: string;
  innerItems?: JSX.Element
  disabled?: any;
  localeDate?: any;
  onBlur?: any;
  type: string;
  limitedLength?: number;
  titleCheckbox?: string
  radioOptions?: any;
  treeNodeOptions?: any;
  defaultValue?: any;
  value?: number;
  hour?: boolean | object;
  onRemoveImage: Function;
};

interface IFieldsValidationStateType {
  inputValue: string;
};
export default class FieldsValidation extends React.Component<IFieldsValidationPropsType, IFieldsValidationStateType> {

  constructor(props: IFieldsValidationPropsType) {
    super(props);
  }


  render() {
    const msgValidation = (validation : any) => !validation && <p style={{ color: 'red' }} >{this.props.messageValidation}</p>
    const {
      limitedLength,
      defaultValue
    } = this.props;
    return (
      <div style={{width: '100%'}}>
        {this.props.type === TypesValidation.INPUT &&
            <Input
              style={this.props.validation === false ? { width: '90%', borderColor: 'red' } : { width: '90%' }}
              placeholder={I18n.l('label.inputPlaceholder')}
              onChange={this.props.handleOnChange}
              maxLength={limitedLength}
              defaultValue={defaultValue}
            />
        }
        {this.props.type === TypesValidation.TEXAREA &&
            <TextArea
              style={this.props.validation === false ? { width: '90%', borderColor: 'red' } : { width: '90%' }}
              placeholder={I18n.l('label.inputPlaceholder')}
              onChange={this.props.handleOnChange}
              rows={4}
              defaultValue={defaultValue}
            />
        }
        {this.props.type === TypesValidation.NUMBER &&
            <InputNumber
              style={this.props.validation === false ? { width: '90%', borderColor: 'red' } : { width: '90%' }}
              placeholder={I18n.l('label.inputNumberPlaceholder')}
              defaultValue={this.props.defaultValue}
              onChange={this.props.handleOnChange}
              parser={(v: any) => v.toString().match(/^(?!,$)[\d,.-]+/g) ? v.toString().match(/^(?!,$)[\d,.-]+/g).join([]) : ''}
              value={this.props.value || undefined}
            />
        }
        {this.props.type === TypesValidation.DATE &&
            <DatePicker
              //  style={this.props.validation ? { width: '90%', borderColor: 'red' } : { width: '90%' }}
              format={I18n.l(this.props.hour ? 'common.dateTimeFormat' : 'common.dateFormat')}
              locale={this.props.localeDate}
              disabledDate={this.props.disabled}
              onChange={this.props.handleOnChange}
              // defaultValue={moment(convertingDateMin)}
              onOpenChange={this.props.onBlur}
              placeholder={I18n.l(this.props.hour ? 'label.dateTimePlaceholder' : 'label.datePlaceholder')}
              className={this.props.validation ? 'ant-calendar-picker-input' : ''}
              defaultValue={defaultValue}
              showTime={this.props.hour}
              
            />
        }
        {(this.props.type === TypesValidation.IMAGE || this.props.type === TypesValidation.FILEUPLOAD) &&
            <UploadComponent
              // onValidate={this.setImageValidator}
              buttonTitle={I18n.l('form.products.buttonImage')}
              customListType={'picture'}
              isStorage={true}
              accept={this.props.type === TypesValidation.FILEUPLOAD ? '.zip, .jpg, .jpeg, .png, .pdf' : undefined}
              defaultFileList={this.props.defaultValue}
              onFileListChange={this.props.handleOnChange}
              validateUpload={this.setImageValidator}
              onRemoveImage={this.props.onRemoveImage}
              type={this.props.type}
            />
        }
        {this.props.type === TypesValidation.CHECKBOX &&
          <Checkbox
            defaultChecked={this.props.defaultValue}
            onChange={this.props.handleOnChange}
          >
            {this.props.titleCheckbox}
          </Checkbox>
        }
        {this.props.type === TypesValidation.RADIO &&
          <Radio.Group key={this.props.defaultValue} onChange={this.props.handleOnChange} defaultValue={this.props.defaultValue}>
            {this.props.radioOptions}
          </Radio.Group>
        }
        {this.props.type === TypesValidation.TREEVIEW &&
          <Tree 
            checkable 
            onCheck={this.props.handleOnChange}
          >
            {this.props.treeNodeOptions}
          </Tree>
        }
        {this.props.innerItems}
        {typeof this.props.validation === 'boolean' && msgValidation(this.props.validation)}
      </div>
    );
  }
}
